import { ListItemButton, ListItemText } from "@mui/material";
import React from "react";

export type SuggestionItemProps = {
  title: string;
  text: string;
  onClick: (text: string) => void;
};

const SuggestionItem = ({ title, text, onClick }: SuggestionItemProps) => {
  return (
    <ListItemButton
      onClick={() => onClick(text)}
      sx={{
        borderRadius: "28px",
        py: "0.75rem",
        px: "1rem",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.05), 0 1px 4px rgba(0, 0, 0, 0.05)",
        "&:hover": {
          backgroundColor: "#fbfbfb",
        },
      }}
    >
      <ListItemText
        primary={title}
        secondary={text}
        primaryTypographyProps={{ fontWeight: "bold", fontSize: "14px", color: "rgb(0, 48, 135)" }}
        secondaryTypographyProps={{ fontSize: "13px", color: "#545859", mt: "0.25rem" }}
      />
    </ListItemButton>
  );
};

export default React.memo(SuggestionItem);
